module.exports = {
	"articleTitle1": "Baked Buzzed Bored: Our trip to the hipster graveyard, Urban Outfitters",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Urban Outfitters",
	"articleLink2": "https://www.michigandaily.com/section/arts/music-video-review-new-americana",
	"articleSnippet1": "Sep 28, 2016 ... “I just wanna love U” by Jay Z and Pharrell is playing ..... predictable yet not \nproblematic. Buzzed is living up to her title from her wine-vodka mix.",
	"articleSnippet2": "Sep 30, 2015 ... Halsey is one of those girls. You know the ones: They can rock the mystical \nshoulder tattoos, the Smurf-blue hair, the elusive ultra-pixie cut, the ...",
	"totalMisc": 0,
	"articleTitle2": "Music Video Review: Halsey is too Urban Outfitters in 'New Americana'",
	"address": "231 S State St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279518,
		"lng": -83.7405
	},
	"tips": [
		{
			"text": "A good option for cliche secret santa gifts",
			"person": "Bob Lesser"
		}
	],
	"articleLink1": "#",
	"categories": {
		"clothingstore": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/urbanoutfitters.json
// module id = 996
// module chunks = 0